export enum HttpRequestMethods {
    GET = "GET",
    POST = "POST"
}
export const AuthToken = "AuthToken";

